import React, { useCallback } from 'react';
import { AppBar as MuiAppBar, Toolbar, IconButton, Button, Tooltip, Box, useMediaQuery, useTheme } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FaBars as MenuIcon, 
  FaRedo as RedoIcon, 
  FaBrush as BrushIcon,
  FaUser as SignInIcon,
  FaPowerOff as SignOutIcon
} from 'react-icons/fa';
import useStyles from './styles';
import useThemeStore from '../../store/theme';
import useSW from '../../store/sw';
import { useAuth } from '../../utils/useAuth';
import { title } from '../../config';

function AppBar_({ onMenuOpen }) {
  const { classes } = useStyles();
  const [, themeActions] = useThemeStore();
  const [swState, swActions] = useSW();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleToggleTheme = useCallback(() => {
    themeActions.toggle();
  }, [themeActions]);

  const handleAppUpdate = useCallback(() => {
    swActions.update();
  }, [swActions]);

  // Add this new function
  const renderUpdateButton = () => (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleAppUpdate}
      startIcon={<RedoIcon />}
      sx={{ mr: 2 }}
    >
      Update App
    </Button>
  );

  const handleSignOut = useCallback(async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Error signing out: ', error);
    }
  }, [logout, navigate]);

  const handleSignIn = useCallback(() => {
    navigate('/login');
  }, [navigate]);

  return (
    <MuiAppBar
      position="fixed"
      className={classes.appBar}
      color="default"
      elevation={1}
    >
      <Toolbar className={classes.toolbar}>
        <Box display="flex" alignItems="center" flexGrow={1}>
        {!isMobile ?
          <IconButton
            edge="start"
            aria-label="open menu"
            onClick={onMenuOpen}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          : null}
          <Link to="/" style={{ textDecoration: 'none' }}>
            <Button aria-label="go to home" className={classes.title}>
              {isMobile ? 'PIE' : title}
            </Button>
          </Link>
        </Box>
        <Box display="flex" alignItems="center">
          {swState.isUpdated && renderUpdateButton()}
          {!isMobile && swState.isUpdated && (
            <>
              <Tooltip title="The application has newer version; press to update" arrow>
                <IconButton aria-label="update the application" color="secondary" onClick={handleAppUpdate}>
                  <RedoIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
          {user ? (
            <Tooltip title="Sign Out" arrow>
              <IconButton
                aria-label="sign out"
                edge="end"
                onClick={handleSignOut}
                sx={{ color: 'pink' }} // Change color for sign-out
              >
                <SignOutIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Sign In" arrow>
              <IconButton
                aria-label="sign in"
                edge="end"
                onClick={handleSignIn}
                sx={{ color: 'lightblue' }} // Change color for sign-in
              >
                <SignInIcon />
              </IconButton>
            </Tooltip>
          )}
          {!isMobile && (
            <Tooltip title="Change theme" arrow>
              <IconButton
                aria-label="toggle theme"
                edge="end"
                onClick={handleToggleTheme}
              >
                <BrushIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Toolbar>
    </MuiAppBar>
  );
}

export default AppBar_;